import { Disc3, Music, Phone, Sparkles } from "lucide-react";
import business from "../data/business.json";
import { SectionTitle } from "./SectionTitle";
import { Reveal } from "./Reveal";

const TYPES = [
    {
        icon: Music,
        title: "Musica dal vivo",
        lines: ["Serate con musica dal vivo e spettacoli dal vivo.", "È uno dei temi più citati dagli ospiti nelle recensioni."],
    },
    {
        icon: Disc3,
        title: "DJ set",
        lines: ["Alcune sere la colonna sonora la fa un DJ.", "Lo citano più volte gli ospiti su Google."],
    },
    {
        icon: Sparkles,
        title: "Serate a tema, anche gastronomiche",
        lines: ["Proposte che si alternano nel corso della stagione.", "Anche a tema gastronomico."],
    },
];

export const Evenings = () => (
    <section id="serate" className="bg-carbone py-20 md:py-28">
        <div className="container-pub">
            <Reveal>
                <SectionTitle eyebrow="Serate ed eventi" title="Le sere al River" />
            </Reveal>
            <div className="mt-10 grid sm:grid-cols-3 gap-6">
                {TYPES.map((t, i) => (
                    <Reveal key={t.title} delay={i * 0.08} className="h-full">
                        <article className="rounded-xl border border-bordo bg-superficie p-6 h-full">
                            <t.icon className="w-7 h-7 text-ambra" strokeWidth={1.5} />
                            <h3 className="font-heading uppercase tracking-wide text-xl mt-4">{t.title}</h3>
                            <p className="mt-2 text-[15px] text-avorio/75">
                                {t.lines[0]}
                                <br />
                                {t.lines[1]}
                            </p>
                        </article>
                    </Reveal>
                ))}
            </div>
            <Reveal className="mt-12">
                <div className="rounded-xl border border-ambra/40 bg-superficie p-6 sm:p-8 flex flex-col sm:flex-row sm:items-center gap-5 sm:justify-between">
                    <div>
                        <h3 className="font-heading uppercase tracking-wide text-2xl">
                            Prenotazioni per gruppi e serate
                        </h3>
                        <p className="mt-1 text-avorio/80">Siete in tanti? Il modo più rapido per organizzarvi: chiamarci.</p>
                    </div>
                    <a className="btn btn-amber shrink-0" href={business.phone.href} data-testid="events-booking-call">
                        <Phone className="w-[18px] h-[18px]" /> Chiama lo {business.phone.display}
                    </a>
                </div>
            </Reveal>
        </div>
    </section>
);